import {
    FETCH_AVAILABLE_INVOICE_REQUEST,
    FETCH_AVAILABLE_INVOICE_SUCCESS,
    FETCH_AVAILABLE_INVOICE_FAILED,
    DOWNLOAD_SIMPLE_EXCEL_REQUEST,
    DOWNLOAD_SIMPLE_EXCEL_SUCCESS,
    DOWNLOAD_SIMPLE_EXCEL_FAILED,
    DOWNLOAD_DETAIL_CSV_REQUEST,
    DOWNLOAD_DETAIL_CSV_SUCCESS,
    DOWNLOAD_DETAIL_CSV_FAILED,
    DOWNLOAD_INVOICE_PDF_REQUEST,
    DOWNLOAD_INVOICE_PDF_SUCCESS,
    DOWNLOAD_INVOICE_PDF_FAILED,
    FETCH_INVOICE_MONTHS_REQUEST,
    FETCH_INVOICE_MONTHS_SUCCESS,
    FETCH_INVOICE_MONTHS_FAILED,
    FETCH_SUMMARY_STATISTICS_REQUEST,
    FETCH_SUMMARY_STATISTICS_SUCCESS,
    FETCH_SUMMARY_STATISTICS_FAILED,
    FETCH_SUMMARY_MONTHS_REQUEST,
    FETCH_SUMMARY_MONTHS_SUCCESS,
    FETCH_SUMMARY_MONTHS_FAILED,
    FETCH_SUMMARY_REGIONS_REQUEST,
    FETCH_SUMMARY_REGIONS_SUCCESS,
    FETCH_SUMMARY_REGIONS_FAILED,
    FETCH_SUMMARY_WEEKS_REQUEST,
    FETCH_SUMMARY_WEEKS_SUCCESS,
    FETCH_SUMMARY_WEEKS_FAILED,
    FETCH_SUMMARY_DATES_REQUEST,
    FETCH_SUMMARY_DATES_SUCCESS,
    FETCH_SUMMARY_DATES_FAILED,
    FETCH_SUMMARY_PRODUCTS_REQUEST,
    FETCH_SUMMARY_PRODUCTS_SUCCESS,
    FETCH_SUMMARY_PRODUCTS_FAILED,
    FETCH_SUMMARY_COMPARE_ESTIMATED_REQUEST,
    FETCH_SUMMARY_COMPARE_ESTIMATED_SUCCESS,
    FETCH_SUMMARY_COMPARE_ESTIMATED_FAILED,
    FETCH_SUMMARY_COMPARE_PREV_MONTH_REQUEST,
    FETCH_SUMMARY_COMPARE_PREV_MONTH_SUCCESS,
    FETCH_SUMMARY_COMPARE_PREV_MONTH_FAILED,
    FETCH_TOTAL_COST_REQUEST,
    FETCH_TOTAL_COST_SUCCESS,
    FETCH_TOTAL_COST_FAILED,
    FETCH_SUMMARY_DETAIL_REQUEST,
    FETCH_SUMMARY_DETAIL_SUCCESS,
    FETCH_SUMMARY_DETAIL_FAILED,
    FETCH_COST_BY_MONTH_REQUEST,
    FETCH_COST_BY_MONTH_SUCCESS,
    FETCH_COST_BY_MONTH_FAILED,
    FETCH_MODEL_WIDGET,
    FETCH_CUSTOM_DASHBOARD_REQUEST,
    FETCH_CUSTOM_DASHBOARD_SUCCESS,
    FETCH_CUSTOM_DASHBOARD_FAILED,
    SAVE_CUSTOM_DASHBOARD_REQUEST,
    SAVE_CUSTOM_DASHBOARD_SUCCESS,
    SAVE_CUSTOM_DASHBOARD_FAILED,
    RESET_CUSTOM_DASHBOARD_REQUEST,
    RESET_CUSTOM_DASHBOARD_SUCCESS,
    RESET_CUSTOM_DASHBOARD_FAILED,
    UPDATE_EDIT_DASHBOARD,
    FETCH_CURRENT_PARAMS
} from './mutation-type'
import { defaultLayout } from '@/modules/Dashboard/_store/dummy-data'
const mutations = {
    /** common */
    [FETCH_AVAILABLE_INVOICE_REQUEST]: state => {
        state.status.hasInvoice = 'loading'
    },
    [FETCH_AVAILABLE_INVOICE_SUCCESS]: (state, data) => {
        state.hasInvoice = data.data
        state.status.hasInvoice = 'success'
    },
    [FETCH_AVAILABLE_INVOICE_FAILED]: (state, error) => {
        state.status.hasInvoice = 'error'
    },
    [DOWNLOAD_SIMPLE_EXCEL_REQUEST]: state => {
        state.download.simpleExcel = true
        state.status.download.simpleExcel = 'loading'
    },
    [DOWNLOAD_SIMPLE_EXCEL_SUCCESS]: state => {
        state.download.simpleExcel = false
        state.status.download.simpleExcel = 'success'
    },
    [DOWNLOAD_SIMPLE_EXCEL_FAILED]: state => {
        state.status.download.simpleExcel = 'error'
        state.download.simpleExcel = false
    },
    [DOWNLOAD_DETAIL_CSV_REQUEST]: state => {
        state.status.download.detailCSV = 'loading'
        state.download.detailCSV = true
    },
    [DOWNLOAD_DETAIL_CSV_SUCCESS]: (state, data) => {
        state.download.detailCSV = false
        state.status.download.detailCSV = 'success'
    },
    [DOWNLOAD_DETAIL_CSV_FAILED]: (state, error) => {
        state.status.download.detailCSV = 'error'
        state.download.detailCSV = false
    },
    [DOWNLOAD_INVOICE_PDF_REQUEST]: state => {
        state.status.download.invoicePDF = 'loading'
        state.download.invoicePDF = true
    },
    [DOWNLOAD_INVOICE_PDF_SUCCESS]: (state, data) => {
        state.download.invoicePDF = false
        state.status.download.invoicePDF = 'success'
    },
    [DOWNLOAD_INVOICE_PDF_FAILED]: (state, error) => {
        state.status.download.invoicePDF = 'error'
        state.download.invoicePDF = false
    },
    [FETCH_INVOICE_MONTHS_REQUEST]: state => {
        state.status.invoiceMonths = 'loading'
    },
    [FETCH_INVOICE_MONTHS_SUCCESS]: (state, data) => {
        state.invoiceMonths = data
        state.status.invoiceMonths = 'success'
    },
    [FETCH_INVOICE_MONTHS_FAILED]: (state, error) => {
        state.status.invoiceMonths = 'error'
    },
    /** summary */
    [FETCH_SUMMARY_STATISTICS_REQUEST]: state => {
        state.status.summaryStatistics = 'loading'
    },
    [FETCH_SUMMARY_STATISTICS_SUCCESS]: (state, { data, status, params }) => {
        if (JSON.stringify(state.currentParams) !== JSON.stringify(params)) return
        if (status === 204) {
            state.summaryStatistics = {
                lineitems: 0,
                products: 0
            }
        } else {
            state.summaryStatistics = data.data
        }
        state.status.summaryStatistics = 'success'
    },
    [FETCH_SUMMARY_STATISTICS_FAILED]: (state, { error, params }) => {
        if (JSON.stringify(state.currentParams) !== JSON.stringify(params)) return
        state.status.summaryStatistics = 'error'
    },
    [FETCH_SUMMARY_MONTHS_REQUEST]: state => {
        state.summaryMonths = {
            list: [],
            maxCost: 0
        }
        state.status.summaryMonths = 'loading'
    },
    [FETCH_SUMMARY_MONTHS_SUCCESS]: (state, { data, status, params }) => {
        if (JSON.stringify(state.currentParams) !== JSON.stringify(params)) return
        if (status === 204) {
            state.summaryMonths = {
                list: [],
                maxCost: 0
            }
        } else {
            state.summaryMonths = {
                list: data.data.months,
                maxCost: Math.max.apply(null, data.data.months.map(item => item.cost))
            }
        }
        state.status.summaryMonths = 'success'
    },
    [FETCH_SUMMARY_MONTHS_FAILED]: (state, { error, params }) => {
        if (JSON.stringify(state.currentParams) !== JSON.stringify(params)) return
        state.status.summaryMonths = 'error'
    },
    [FETCH_SUMMARY_REGIONS_REQUEST]: state => {
        state.summaryRegions = {
            lastMonthRegions: [],
            thisMonthRegions: []
        }
        state.status.summaryRegions = 'loading'
    },
    [FETCH_SUMMARY_REGIONS_SUCCESS]: (state, { data, status, params }) => {
        if (JSON.stringify(state.currentParams) !== JSON.stringify(params)) return
        if (status === 204) {
            state.summaryRegions = {
                lastMonthRegions: [],
                thisMonthRegions: []
            }
        } else {
            state.summaryRegions = {
                lastMonthRegions: data.data.lastMonthRegions ?? [],
                thisMonthRegions: data.data.thisMonthRegions ?? []
            }
        }
        state.status.summaryRegions = 'success'
    },
    [FETCH_SUMMARY_REGIONS_FAILED]: (state, { error, params }) => {
        if (JSON.stringify(state.currentParams) !== JSON.stringify(params)) return
        state.status.summaryRegions = 'error'
    },
    [FETCH_SUMMARY_WEEKS_REQUEST]: state => {
        state.summaryWeeks = {
            days: [],
            yKeys: [],
            weeklyCost: {}
        }
        state.status.summaryWeeks = 'loading'
    },
    [FETCH_SUMMARY_WEEKS_SUCCESS]: (state, { data, status, params }) => {
        if (JSON.stringify(state.currentParams) !== JSON.stringify(params)) return
        if (status === 204) {
            state.summaryWeeks = {
                weeks: [],
                days: [],
                yKeys: [],
                weeklyCost: {}
            }
        } else {
            const isWeeks = {}
            state.summaryWeeks = data.data.weeks.reduce((acc, item) => {
                if (!isWeeks[item.week]) {
                    isWeeks[item.week] = true
                    acc.yKeys.push(item.week)
                }
                if (!acc.weeklyCost[item.week]) {
                    acc.weeklyCost[item.week] = new Array(7).fill(null)
                }
                acc.weeklyCost[item.week][item.day - 1] = (item.cost)
                return acc
            }, {
                days: [1, 2, 3, 4, 5, 6, 7],
                yKeys: [],
                weeklyCost: {}
            })
            state.summaryWeeks.weeks = data.data.weeks
        }
        state.status.summaryWeeks = 'success'
    },
    [FETCH_SUMMARY_WEEKS_FAILED]: (state, { error, params }) => {
        if (JSON.stringify(state.currentParams) !== JSON.stringify(params)) return
        state.status.summaryWeeks = 'error'
    },
    [FETCH_SUMMARY_DATES_REQUEST]: state => {
        state.status.summaryDates = 'loading'
    },
    [FETCH_SUMMARY_DATES_SUCCESS]: (state, { data, status, params }) => {
        if (JSON.stringify(state.currentParams) !== JSON.stringify(params)) return
        if (status === 204) {
            state.summaryDates = {
                lineChartData: [],
                barChartData: [],
                labels: [],
                costOfAfterThisMonth: 0,
                dates: []
            }
        } else {
            const thisMonth = data.data.dates[0].date.substring(0, 7)
            state.summaryDates = data.data.dates.reduce((acc, cur, index) => {
                if (thisMonth === cur.date.substring(0, 7)) {
                    acc.lineChartData.push(cur.cost)
                    if (acc.lineChartData[index - 1]) {
                        acc.lineChartData[index] += acc.lineChartData[index - 1]
                    }
                    acc.barChartData.push(cur.cost)
                    acc.labels.push(cur.date.substring(8, 10))
                } else {
                    acc.costOfAfterThisMonth += cur.cost
                }

                return acc
            }, {
                lineChartData: [],
                barChartData: [],
                labels: [],
                costOfAfterThisMonth: 0
            })
            state.summaryDates.dates = data.data.dates
        }
        state.status.summaryDates = 'success'
    },
    [FETCH_SUMMARY_DATES_FAILED]: (state, { error, params }) => {
        if (JSON.stringify(state.currentParams) !== JSON.stringify(params)) return
        state.status.summaryDates = 'error'
    },
    [FETCH_SUMMARY_PRODUCTS_REQUEST]: state => {
        state.status.summaryProducts = 'loading'
    },
    [FETCH_SUMMARY_PRODUCTS_SUCCESS]: (state, { data, status, params }) => {
        if (JSON.stringify(state.currentParams) !== JSON.stringify(params)) return
        if (status === 204) {
            state.summaryProducts = {
                thisMonthProducts: [],
                lastMonthProducts: []
            }
        } else {
            state.summaryProducts = {
                thisMonthProducts: data.data.thisMonthProducts ?? [],
                lastMonthProducts: data.data.lastMonthProducts ?? []
            }
        }
        state.status.summaryProducts = 'success'
    },
    [FETCH_SUMMARY_PRODUCTS_FAILED]: (state, { error, params }) => {
        if (JSON.stringify(state.currentParams) !== JSON.stringify(params)) return
        state.status.summaryProducts = 'error'
    },
    [FETCH_SUMMARY_COMPARE_ESTIMATED_REQUEST]: state => {
        state.status.compareEstimated = 'loading'
    },
    [FETCH_SUMMARY_COMPARE_ESTIMATED_SUCCESS]: (state, { data, params }) => {
        state.compareEstimated = data.data
        state.status.compareEstimated = 'success'
    },
    [FETCH_SUMMARY_COMPARE_ESTIMATED_FAILED]: (state, { error, params }) => {
        state.status.compareEstimated = 'error'
    },
    [FETCH_SUMMARY_COMPARE_PREV_MONTH_REQUEST]: state => {
        state.status.comparePrevMonth = 'loading'
    },
    [FETCH_SUMMARY_COMPARE_PREV_MONTH_SUCCESS]: (state, { data, params }) => {
        state.comparePrevMonth = data.data
        state.status.comparePrevMonth = 'success'
    },
    [FETCH_SUMMARY_COMPARE_PREV_MONTH_FAILED]: (state, { error, params }) => {
        state.status.comparePrevMonth = 'error'
    },
    [FETCH_TOTAL_COST_REQUEST]: state => {
        state.status.totalCost = 'loading'
    },
    [FETCH_TOTAL_COST_SUCCESS]: (state, { data, status, isEstimated, params }) => {
        if (JSON.stringify(state.currentParams) !== JSON.stringify(params)) return
        if (status === 204) {
            if (isEstimated) {
                state.totalCost = {
                    'date': null,
                    'cost': null,
                    'lastMonthCost': 0.0,
                    'estimatedCost': 0.0,
                    'estimatedIncreasedRate': 'NaN'
                }
            } else {
                state.totalCost = {
                    'date': null,
                    'cost': null,
                    'lastMonthCost': 0,
                    'monthIncreasedRate': 'NaN'
                }
            }
        } else {
            state.totalCost = data.data
        }
        state.status.totalCost = 'success'
    },
    [FETCH_TOTAL_COST_FAILED]: (state, { error, params }) => {
        if (JSON.stringify(state.currentParams) !== JSON.stringify(params)) return
        state.status.totalCost = 'error'
    },
    [FETCH_SUMMARY_DETAIL_REQUEST]: state => {
        state.status.detail = 'loading'
    },
    [FETCH_SUMMARY_DETAIL_SUCCESS]: (state, { data, status }) => {
        state.status.detail = status
        state.detail = data
    },
    [FETCH_SUMMARY_DETAIL_FAILED]: (state, error) => {
        state.status.detail = 'error'
    },
    [FETCH_COST_BY_MONTH_REQUEST]: state => {
        state.status.cost = 'loading'
    },
    [FETCH_COST_BY_MONTH_SUCCESS]: (state, { data, status, params }) => {
        if (JSON.stringify(state.currentParams) !== JSON.stringify(params)) return
        state.status.cost = status === 200 ? 'success' : status
        if (status === 204) {
            state.cost = null
        } else if (data.length) {
            state.cost = data[0].cost
        } else {
            state.cost = data.cost
        }
    },
    [FETCH_COST_BY_MONTH_FAILED]: (state, { error, params }) => {
        if (JSON.stringify(state.currentParams) !== JSON.stringify(params)) return
        state.status.cost = 'error'
    },
    [FETCH_MODEL_WIDGET]: (state, data) => {
        state.widget.cardModel = data
    },
    [FETCH_CUSTOM_DASHBOARD_REQUEST]: (state, data) => {
        state.customDashboardIdx = null
        state.status.getCustomDashboard = 'loading'
    },
    [FETCH_CUSTOM_DASHBOARD_SUCCESS]: (state, data) => {
        const doneTourJson = JSON.parse(localStorage.getItem('doneTour')) || {}
        localStorage.setItem(
            'doneTour',
            JSON.stringify({
                dashboard: doneTourJson.dashboard || ((typeof data.data?.dashboardIdx || null) === 'number'),
                editDashboard: doneTourJson.editDashboard || ((typeof data.data?.dashboardIdx || null) === 'number')
            })
        )

        const scaleFactor = data.data?.coordinate[0] && data.data?.coordinate[0].maxW === 24 ? 1 : 2
        state.customDashboard = (scaleFactor === 1 ? data.data?.coordinate : data.data?.coordinate?.map((item) => ({
            ...item,
            x: item.x * scaleFactor,
            w: item.w * scaleFactor,
            minW: item.minW * scaleFactor,
            maxW: 24
        }))) || defaultLayout
        state.customDashboardIdx = data.data?.dashboardIdx || null
        state.status.getCustomDashboard = 'success'
    },
    [FETCH_CUSTOM_DASHBOARD_FAILED]: (state, data) => {
        state.status.getCustomDashboard = 'error'
    },
    [SAVE_CUSTOM_DASHBOARD_REQUEST]: (state, data) => {
        state.status.saveCustomDashboard = 'loading'
    },
    [SAVE_CUSTOM_DASHBOARD_SUCCESS]: (state, data) => {
        state.status.saveCustomDashboard = 'success'
    },
    [SAVE_CUSTOM_DASHBOARD_FAILED]: (state, data) => {
        state.status.saveCustomDashboard = 'error'
    },
    [RESET_CUSTOM_DASHBOARD_REQUEST]: (state, data) => {
        state.status.resetCustomDashboard = 'loading'
    },
    [RESET_CUSTOM_DASHBOARD_SUCCESS]: (state, data) => {
        state.status.resetCustomDashboard = 'success'
    },
    [RESET_CUSTOM_DASHBOARD_FAILED]: (state, data) => {
        state.status.resetCustomDashboard = 'error'
    },
    [UPDATE_EDIT_DASHBOARD]: (state, data) => {
        state.editDashboard = data
    },
    [FETCH_CURRENT_PARAMS]: (state, data) => {
        state.currentParams = data
    }
}

export default mutations
